<template>
  <div class="col-md-11 visits__items">
    <div v-if="diagnosticsVisitCurrent.length === 0 || !diagnosticsVisitCurrent">
      <div class="not-found row mt-5">
        <div class="col-3 d-flex justify-content-end">
          <img src="~@/assets/images/zero-illu-01.svg" alt="">
        </div>
        <div class="col-7">
          <div class="mb-3" v-html="$t('diagnostic.empty.text')">
          </div>

          <router-link :to="{name:'profile.order.find-diagnostic'}" class="btn w-auto">
            {{
              $t('diagnostic.empty.button')
            }}
          </router-link>
        </div>
      </div>
    </div>

    <div class="visits__item row" v-for="diagnosticVisitCurrent in diagnosticsVisitCurrent">
      <div class="date col-3">
        {{ formatDate(diagnosticVisitCurrent.date_time) }}
        <span>{{ formatTime(diagnosticVisitCurrent.date_time) }}</span>
      </div>

      <div class="col-5">
        <div class="text">{{ diagnosticVisitCurrent.name }}</div>
      </div>
      <div class="text col-4">
        {{ getClinicName(diagnosticVisitCurrent) }}
      </div>
      <!--      <div class="text col-2">-->
      <!--        <button v-if="diagnosticVisitCurrent.payment_status != 'PAY'"-->
      <!--                @click="pay(diagnosticVisitCurrent)"-->
      <!--                type="button"-->
      <!--                class="btn btn-sm btn-green">-->
      <!--          Оплатить-->
      <!--        </button>-->
      <!--      </div>-->

      <!--<button class="icon__close" @click="selectVisitCurrent(diagnosticVisitCurrent)"></button>-->

      <div class="delimiter w-100"></div>
    </div>

    <b-modal ref="confirmationModal" centered hide-footer :title="$t('common.confirm')">
      {{ $t('common.a_u_sure') }}

      <div class="mt-3">
        <button class="btn-blue" @click="cancelVisitCurrent()">{{ $t('common.yes') }}</button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import config from '@/helpers/configDateFormats';

export default {
  name: 'diagnostics-current',
  data() {
    return {
      selectedVisitCurrentCancel: null,
    };
  },
  computed: {
    ...mapGetters({
      diagnosticsVisitCurrent: 'diagnosticsCurrent',
      clinics: 'clinics'
    }),
  },
  methods: {
    formatTime(date) {
      return moment(date).format(config.TIME_FORMAT);
    },
    formatDate(date) {
      return moment(date).format(config.DATE_FORMAT_OUTPUT);
    },
    getClinicName(visit) {
      let visitClinic = this.clinics.filter((item) => item.id === visit.clinic)
      if (visitClinic.length > 0) {
        return visitClinic[0].address
      }
      return ''
    },
    selectVisitCurrent(visit) {
      this.selectedVisitCurrentCancel = visit;
      this.$refs.confirmationModal.show();
    },
    cancelVisitCurrent() {
      this.$store
          .dispatch('setVisitCurrentCancel', this.selectedVisitCurrentCancel)
          .then(() => {
            this.$refs.confirmationModal.hide();

            this.$store.dispatch('getVisits', {serviceTypes: ['diagnostic', 'specialization', 'otherService']});
          });
    },
    pay({id}) {
      this.$store.dispatch('getVisitPaymentLink', id)
          .then(({data: {enter_url, params}}) => {
            this.$refs.confirmationModal.hide();

            let form = document.createElement("form");

            form.setAttribute("method", 'POST');
            form.setAttribute("target", '_blank');
            form.setAttribute("action", enter_url);

            for (let paramKey in params) {
              let hiddenField = document.createElement("input");

              hiddenField.setAttribute("type", "hidden");
              hiddenField.setAttribute("name", paramKey);
              hiddenField.setAttribute("value", params[paramKey]);

              form.appendChild(hiddenField);
            }

            document.body.appendChild(form);

            form.submit();
          });
    },
  }
}
</script>
